import script from "./SuccessView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccessView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__